import type { SemanticICONS } from 'semantic-ui-react';

import { ArtifactType } from './artifact-type.models';

export interface ArtifactTypeMetadata {
  /**
   * Short display label for the Artifact Type (e.g., "Image", "SBOM")
   */
  label: string;
  /**
   * Long-form title for the Artifact Type (e.g., "Container Image").
   * Falls back to `label` if not provided.
   */
  title?: string;
  /**
   * Icon name that will decorate the Artifact Type
   */
  icon: SemanticICONS;
}

export const artifactTypeMetadata: Record<ArtifactType, ArtifactTypeMetadata> =
  {
    [ArtifactType.Image]: {
      label: 'Image',
      title: 'Container Image',
      icon: 'tags',
    },
    [ArtifactType.SBOM]: {
      label: 'SBOM',
      icon: 'file archive',
    },
    [ArtifactType.Source]: {
      label: 'Repository',
      title: 'Source Repository',
      icon: 'code branch',
    },
  };

/**
 * Get metadata for an artifact type
 */
export const getArtifactTypeMetadata = (
  type: ArtifactType,
): ArtifactTypeMetadata => artifactTypeMetadata[type];
